/*
 * @Descripttion:
 * @version:
 * @Author: afeng510
 * @Date: 2021-08-11 20:35:52
 * @LastEditors: afeng510
 * @LastEditTime: 2021-08-31 16:02:57
 */
const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  userInfo: state => state.user.userInfo,

}
export default getters
